const SvgIcon = ({ size='24', color='#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      strokeWidth="0.453"
      d="M15.075 10.94 9.981 9.46c-.59-.17-1-.718-1-1.327 0-.764.623-1.383 1.391-1.383H13.5c.575 0 1.141.173 1.613.492a.74.74 0 0 0 .92-.094l1.641-1.593c.335-.324.288-.863-.085-1.149A6.7 6.7 0 0 0 13.51 3V.75c0-.413-.34-.75-.755-.75h-1.509a.755.755 0 0 0-.755.75V3h-.118c-3.004 0-5.42 2.564-5.141 5.606.198 2.161 1.858 3.919 3.953 4.528l4.835 1.407c.59.173 1 .717 1 1.326 0 .764-.623 1.383-1.392 1.383H10.5a2.9 2.9 0 0 1-1.613-.492.74.74 0 0 0-.92.094l-1.642 1.593c-.335.324-.288.863.085 1.149 1.156.9 2.6 1.401 4.08 1.406v2.25c0 .413.34.75.755.75h1.51a.755.755 0 0 0 .754-.75v-2.26c2.198-.042 4.26-1.34 4.986-3.407 1.014-2.888-.689-5.85-3.42-6.642"
    ></path>
  </svg>
);

export default SvgIcon;
